module.exports = __webpack_public_path__ + "img/card12.2abb0d39.jpg";